var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.5 4A1.5 1.5 0 0 0 4 5.5v13A1.5 1.5 0 0 0 5.5 20h13a1.5 1.5 0 0 0 1.5-1.5V5.414a.5.5 0 0 0-.146-.353l-.915-.915A.5.5 0 0 0 18.586 4H18v6.5a1.5 1.5 0 0 1-1.5 1.5h-8A1.5 1.5 0 0 1 7 10.5V4zM8 4h9v6.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5zM3 5.5A2.5 2.5 0 0 1 5.5 3h13.086a1.5 1.5 0 0 1 1.06.44l.915.914A1.5 1.5 0 0 1 21 5.414V18.5a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 18.5zM13.5 5H13v5h3V5h-2.5m.5 4V6h1v3z",
    clipRule: "evenodd"
  })));
});
const SvgSave = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSave);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik01LjUgNEM0LjY3MTU3IDQgNCA0LjY3MTU3IDQgNS41VjE4LjVDNCAxOS4zMjg0IDQuNjcxNTcgMjAgNS41IDIwSDE4LjVDMTkuMzI4NCAyMCAyMCAxOS4zMjg0IDIwIDE4LjVWNS40MTQyMUMyMCA1LjI4MTYxIDE5Ljk0NzMgNS4xNTQ0MyAxOS44NTM2IDUuMDYwNjZMMTguOTM5MyA0LjE0NjQ1QzE4Ljg0NTYgNC4wNTI2OCAxOC43MTg0IDQgMTguNTg1OCA0SDE4VjEwLjVDMTggMTEuMzI4NCAxNy4zMjg0IDEyIDE2LjUgMTJIOC41QzcuNjcxNTcgMTIgNyAxMS4zMjg0IDcgMTAuNVY0SDUuNVpNOCA0SDE3VjEwLjVDMTcgMTAuNzc2MSAxNi43NzYxIDExIDE2LjUgMTFIOC41QzguMjIzODYgMTEgOCAxMC43NzYxIDggMTAuNVY0Wk0zIDUuNUMzIDQuMTE5MjkgNC4xMTkyOSAzIDUuNSAzSDE4LjU4NThDMTguOTgzNiAzIDE5LjM2NTEgMy4xNTgwNCAxOS42NDY0IDMuNDM5MzRMMjAuNTYwNyA0LjM1MzU1QzIwLjg0MiA0LjYzNDg2IDIxIDUuMDE2MzkgMjEgNS40MTQyMVYxOC41QzIxIDE5Ljg4MDcgMTkuODgwNyAyMSAxOC41IDIxSDUuNUM0LjExOTI5IDIxIDMgMTkuODgwNyAzIDE4LjVWNS41Wk0xMy41IDVIMTNWNS41VjkuNVYxMEgxMy41SDE1LjVIMTZWOS41VjUuNVY1SDE1LjVIMTMuNVpNMTQgOVY2SDE1VjlIMTRaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz4KPC9zdmc+Cg==";